import React, { useState, useEffect } from 'react'

const CheckBox = ({ 
  label = '', 
  labelTag = '',
  inputs = [], 
  selectedValues = [], 
  name = '', 
  isMulti = false, 
  inputLabelTags = [],
  classes = '',
  labelClasses = 'text-gray-700', 
  itemClasses = 'text-gray-700', 
  itemNameClasses = 'text-base font-semibold',
  itemTagClasses = 'text-xs text-gray-500',
  labelTagClasses= '', 
  inputsClasses = '',
  inputClasses = '',
  error = '',
  height = 20,
  width = 20,
  br = 'rounded',
  id='',
  onChangeHandler = () => {}
}) => {
  const inputLabelTagsLength = inputLabelTags.length
  const [selected, setSelected] = useState([]);

  const handleChange = (e, data) => {
    const { checked } = e.target;
    let newSelectedItems = checked ? [data] : []
    let newValue = ''
    if(!isMulti){
      setSelected(newSelectedItems)
    }
    else {
      if (checked) {
        newSelectedItems = [...selected, data]
        newValue = data
        setSelected(newSelectedItems);
      } else {
        newSelectedItems = selected.filter((item) => item !== data);
        setSelected(newSelectedItems);
      }
    }
    onChangeHandler({newValueFor: e.target.name, newValue, name, value: newSelectedItems}, id)
  };

  useEffect(() => {
    setSelected(selectedValues)
  }, [selectedValues])

  return (
    <div className={classes}>
      <label className={`font-semibold ${labelClasses}`}>{label}</label>
      {labelTag && <label className={`mb-1 mt-1 block ${labelTagClasses}`}>{labelTag}</label>}
      <div className={`mt-3 ${inputsClasses}`}>
        {
          inputs.map((data, index) => {
            return (
              <div key={`${data.name}_${index}`} className={`mb-3 ${inputClasses}`}>
                <input type="checkbox" name={data.name} checked={selected.includes(data.value)} onChange={(e) => handleChange(e, data.value)}  style={{width: width, height: height}} className={`border border-gray-300 ${br} focus:ring-blue-500`}/>
                <label htmlFor={data.name} className={`inline-flex flex-row ml-3 ${itemClasses}`}>
                  <span className={itemNameClasses}>{data.text}</span>
                  {index < inputLabelTagsLength && <span className={itemTagClasses}>{inputLabelTags[index]}</span>}
                </label>
              </div>
            )
          })
        }
      </div>
      { error && <p className='mb-0 text-red-600'>{error}</p> }
    </div>
  )
}
export default CheckBox
